import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";

import { parametarExtractor } from "../../utils/parametarExtractor.js";
import { Provider } from "mobx-react";

import MultiListOverlay from "sulu-admin-bundle/containers/MultiListOverlay";
import Icon from "sulu-admin-bundle/components/Icon/Icon.js";

import { selectionRegistry } from "./selection/registry.js";

import style from "./styles/selection.module.scss";

const MemberSelection = (props) => {
    const { t } = useTranslation();
    const [overlayOpen, setOverlayOpen] = useState(false);

    const mode = props.schemaOptions?.mode?.value || "player";
    const config = selectionRegistry[mode];
    if (!config) return null;

    const { store, Table } = config;
    const registryEntry = selectionRegistry[mode];

    const { resourceStore } = props.formInspector.formStore;
    const allPositions = props.data.positions;
    const teamId =
        (props.dataPath.includes("Home") && props.data.homeTeam) ||
        (props.dataPath.includes("Away") && props.data.awayTeam) ||
        props.data.id;

    const { disabledIds } = props;
    const { adapter, list_key: listKey } =
        props.fieldTypeOptions.types.list_overlay;
    const { resource_key: resourceKey } = props.fieldTypeOptions;
    const locale = props?.formInspector?.locale || "en";
    const options = parametarExtractor(props);

    useEffect(() => {
        return () => {
            store.removeNotSavedPlayers();
        };
    }, [props.router.schemaPath]);

    useEffect(() => {
        if (
            props.formInspector?.formStore?.data?.isSquadChange ||
            props.formInspector?.formStore?.data?.isStaffChange
        ) {
            if (store.removeDataChange) {
                store.removeDataChange();
                props.onFinish();
            }
        }
    }, [props]);

    useEffect(() => {
        if (store?.loadTeam) {
            store.loadTeam(teamId, locale);
        }
    }, []);

    useEffect(() => {
        if (!store) return;

        registryEntry?.init(
            store,
            resourceStore,
            allPositions,
            teamId,
            props.data.numberOfStartingPlayers,
            props.schemaOptions,
        );
    }, [resourceStore.data.allMatchPlayers, resourceStore.data.allMatchStaff]);

    const handleOverlayConfirm = (items) => {
        const isCoreTeamPlayer =
            props.schemaOptions?.mode?.value === "core_squad";
        const ids = items.map((item) => item.id);
        store.syncSelection(ids, teamId, items, isCoreTeamPlayer);
        setOverlayOpen(false);
    };

    const openModal = () => {
        setOverlayOpen(true);
    };

    return (
        <div>
            <div className={style["selection-warning"]}>
                <Icon name="su-exclamation-triangle" />
                {t(`sulu_admin.selection_important.${mode}`)} <br />
                {t("sulu_admin.selection_instruction")}
            </div>
            <Provider selectionStore={store}>
                <Table
                    resourceStore={resourceStore}
                    props={props}
                    openModal={openModal}
                    teamId={teamId}
                />
            </Provider>
            <MultiListOverlay
                adapter={adapter}
                disabledIds={disabledIds}
                resourceKey={resourceKey}
                listKey={listKey}
                locale={locale}
                onClose={() => setOverlayOpen(false)}
                onConfirm={handleOverlayConfirm}
                open={overlayOpen}
                options={options}
                preSelectedItems={registryEntry.getPreSelectedItems(
                    store,
                    teamId,
                )}
            />
        </div>
    );
};

export default MemberSelection;
